import React, { useContext } from 'react';

import { Config } from '../config';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { useShop } from "./Shop/ShopContext";

// import { Helmet } from 'react-helmet-async';
// import Helmet from 'react-helmet';

// --- SSR loader (used by entry-server.jsx) ---
export async function loadData(url) {
  const { Config } = await import('../config.js');
  // const slug = [pathParam1, pathParam2, pathParam3].filter(Boolean).join('*');

  url = url.replace(/\//g, "*");
  const res = await fetch(`${Config.apiUrl}/page/byUrl/${url}`);

  // 204 / 404 -> page does not exist (null), other errors are thrown so they don't end up as 404
  if (res.status === 204 || res.status === 404) {
    return null;
  }

  if (res.status !== 200) {
    throw new Error(`Page API returned ${res.status}`);
  }

  const data = await res.json();
  return data;
}

// Only provided on the server. Lets entry-server.jsx know that the URL was handled by PageView.
export const SsrPageContext = React.createContext(null);

// True when the client hydrates a server-rendered page. If the first client fetch fails
// (API blocked or down), keep the SSR content instead of replacing it with an error message.
let keepSsrContent = typeof document !== 'undefined' && !!document.getElementById('root')?.firstElementChild;

class PageView extends React.Component
{
    constructor(props)
    {
        super(props);
        this.notFoundState = false;

        // console.log("PageView render PageView " + props.initialData);

        // First client render after SSR: start with the server rendered html. Otherwise React clears
        // the content on the first update and the page is empty until the fetch completes (flicker,
        // and Google sees an empty page if the API call is slow or blocked).
        const ssrHtml = !props.initialData && keepSsrContent
            ? document.getElementById('page-content')?.innerHTML ?? ""
            : "";

        this.state = {
            page: props.initialData
            ? { ...props.initialData, htmlText: props.initialData.htmlText, name: props.initialData.name, url: props.initialData.url, isSSR: true}
            : {
                date: "0001-01-01T00:00:00",
                htmlText: ssrHtml,
                id: 102,
                isMainMenu: true,
                mainMenuPriority: 0,
                name: "About",
                url: "/notExists",
                isSSR: false
                },
            visible: !!props.initialData,
        };

        this.handleOnClick = this.handleOnClick.bind(this);
    }

    fetchPage(urlIn) {
        console.log("fetchPage");

        const keepSsr = keepSsrContent;
        keepSsrContent = false;

        urlIn = urlIn.replace(/\//g, "*");
        fetch(Config.apiUrl + "/page/byUrl/" + urlIn)
            .then(response =>
                {
                    // 204 (page not found) is ok and fails in json() with a SyntaxError like before
                    if (!response.ok) {
                        throw new Error("Page API returned " + response.status);
                    }
                    return response.json();
                })
            .then(data => 
                { 
                    data.htmlText = this.addShopPrice(data.htmlText);
                    this.setState({ page: data, visible: true });
                    // this.notFoundState = false; // keep error state, this is only for cashing
                }) 
            .catch(error => 
                {
                    this.notFoundState = true; // notfound tells prerender.io that the url was not valid

                    if (error instanceof SyntaxError)
                    {
                        // no valid page found. -> does not exist or json is invalid
                        this.notFoundState = true; // notfound tells prerender.io that the url was not valid
                        this.props.navigate("/", { replace: true });
                    }
                    else if (keepSsr)
                    {
                        console.log("Unable to fetch page items, keeping server rendered page", error);
                    }
                    else
                    {

                        console.log("Unable to fetch page items!")
                        this.props.navigate("/messageview", { replace: true, state: { message: "Unable to load page :( Please try again later." } });
                    }
                });
    }

    componentWillUnmount() 
    {
        document.removeEventListener('click', this.handleOnClick, false);
    }

    componentDidCatch(error, info) {
    }   

    componentDidMount()
    {
        // ⚙️ Only fetch if no SSR data
        if (!this.props.initialData) {
            this.componentDidUpdate();
        }
    }

    componentDidUpdate(prevProps, prevState)
    { 
        const { page } = this.state;

        if (prevProps !== undefined && prevProps.products !== this.props.products)
        {
            // products loaded, we can add prices --> only required for the first load
            page.htmlText = this.addShopPrice(page.htmlText);
            this.setState({ page: page, visible: true });
        }

        var separator = '/';
        var currentPathName = separator.concat(this.props.params.pathParam1 ?? '')
                                        .concat(this.props.params.pathParam2 === undefined ? '' : separator.concat(this.props.params.pathParam2 ?? ''))
                                        .concat(this.props.params.pathParam3 === undefined ? '' : separator.concat(this.props.params.pathParam3 ?? ''));

        // console.log("PageView componentDidUpdate " + currentPathName + " vs " + page.url + page.htmlText);

        if (currentPathName.toLowerCase() === page.url.toLowerCase()) 
        {
            return;
        }

        page.url = currentPathName;
        this.fetchPage(currentPathName);
        this.setState({ page: this.state.page, visible: false, notfound: this.state.notfound });
    }

    render()
    {
        const { page } = this.state;
        // console.log("PageView render " + page);

        return (
                <div>
                <div className="container">
                <div id="page-content" suppressHydrationWarning={true} onClick={this.handleOnClick} dangerouslySetInnerHTML={{ __html: page.htmlText }}></div>
                </div>
                </div>
            );
    }

    handleOnClick(e) 
    {
        if (e.metaKey || e.ctrlKey || e.shiftKey) 
        {
            return;
        }

        if (e.target.type === "submit" && this.handleBuyNowButtonClick(e))
        {
            return;
        }

        // Get the <a> element.
        var el = e.target;
        while (el && el.nodeName !== 'A') {
            el = el.parentNode;
        }

        // Ignore clicks from non-a elements.
        if (!el) {
            return;
        }

        // Ignore the click if the element has a target.
        if (el.target && el.target !== '_self') {
            return;
        }

        // Ignore the click if it's a download link. (We use this method of
        // detecting the presence of the attribute for old IE versions.)
        if (el.attributes.download) {
            return;
        }

        let href = (String)(el.getAttribute('href'));
        // Ignore hash (used often instead of javascript:void(0) in strict CSP envs)
        if (href === '#') {
            return;
        }

        if (href.indexOf("/") !== 0) {
            return;
        }
        e.preventDefault();

        this.props.navigate(href);
    }

    getFirsImageUrl(str)
    {
        var searchRegex = "<img[^]*?src=\"(.*?)\"";
        var seReg = new RegExp(searchRegex, "i");
        var result = str.match(seReg);

        if (result == null)
        {
            return "";
        }

        var urlAbsolute = new URL(result[1], window.location.href).href;
        return urlAbsolute;
    }

    getFirstTag(str, tagName)
    {
        var searchRegex = "<" + tagName + ">(.*?)</" + tagName + ">";
        var seReg = new RegExp(searchRegex, "i");
        var result = str.match(seReg);

        if (result == null)
        {
            return "TAL Software GmbH";
        }

        return result[1];
    }

    addShopPrice(rawHtmlString)
    {
        if (window.fastspring === undefined || this.props.products === undefined)
        {
            return rawHtmlString;
        }

        // <ShopPrice product="tal-pha"/>

        // Use DOMParser to parse the raw HTML string into a DOM object
        const parser = new DOMParser();
        const doc = parser.parseFromString(rawHtmlString, 'text/html');
        const elementsWithMyId = doc.querySelectorAll("tal-shopprice");
        if (elementsWithMyId.length === 0)
        {
            return rawHtmlString;
        }

        // Modify the content of each element
        elementsWithMyId.forEach((element, index) => 
        {
            var productPath = element.getAttribute("product");
            var small = element.getAttribute("small");
            var smallText = small !== undefined && small === "true";
            // var product = (productPath => this.props.products.products.find(i => i.path === productPath))[0];

            if (this.props.products.products.length === 0)
            {
                // element.textContent = ""; // clears children
                // element.remove(); // remove element
                return;
            }

            this.props.products.products.forEach((product, index) =>
            {
                if (productPath === product.path)
                {
                    element.textContent = ""; // remove all children

                    if (product === undefined || (smallText && product.discountPercentValue === 0))
                    {
                        element.textContent = ""; 
                        element.remove(); // remove element
                    }
                    else if (product.discountPercentValue > 0)
                    {
                        var surroundingDiv = doc.createElement("div");

                        if (!smallText)
                        {
                            var newPriceElement = doc.createElement("text");
                            newPriceElement.textContent = product.priceValueWithoutTax.toFixed(2).toString() + " " + this.props.data.data.currency + " + VAT ";
                            surroundingDiv.appendChild(newPriceElement);
                        
                            var small = doc.createElement("small");
                            var oldPriceElement = doc.createElement("s");
                            oldPriceElement.textContent =  product.priceValueWithoutTaxAndDiscounts.toFixed(2).toString() + " " + this.props.data.data.currency;
                            small.appendChild(oldPriceElement);
                            surroundingDiv.appendChild(small);
                        }

                        var discountPercent = doc.createElement("div");
                        discountPercent.textContent =  " " + Math.round(product.discountPercentValue.toFixed(0)) + " % OFF";
                        surroundingDiv.appendChild(discountPercent);

                        element.appendChild(surroundingDiv);
                    }
                    else
                    {
                        if (!smallText)
                        {
                            var surroundingDiv2 = doc.createElement("div");

                            var newPriceElement2 = doc.createElement("text");
                            newPriceElement2.setAttribute("class", "shopNewPrice");
                            newPriceElement2.textContent = product.priceValueWithoutTax.toFixed(2).toString() + " " + this.props.data.data.currency + " + VAT ";
                            surroundingDiv2.appendChild(newPriceElement2);
                            element.appendChild(surroundingDiv2);
                        }
                    }
                    /*
                    var price = product.priceValue.toString() + " " + this.props.data.data.currency;
                    var discountInPercent = product.discountPercentValue > 0 
                    ? " " + product.discountPercentValue + "% OFF"
                    : "";*/

                    //element.textContent = priceText; 
                }
            });
        });

        const modifiedHtmlString = doc.documentElement.innerHTML;
        return modifiedHtmlString;
    }

    handleBuyNowButtonClick(e)
    {
        let productName = e.target.getAttribute('productToCheckout');
        if (productName === undefined)
        {
            return false;
        }

        this.buyProductGlobalFastspring(productName);
        return true;
    }

    buyProductGlobalFastspring(productPath)
    {
        if (window.fastspring === undefined)
            return;

        window.fastspring.builder.add(productPath);
        /*
        window.fastspring.builder.push(
            {
                products: [
                {
                    path: productPath,
                    quantity: 1
                }],
                checkout: true
            });
            */

        // window.fastspring.builder.checkout('SessionId');
    }

    buyProductGlobalPaddle(productPath)
    {
        if (global.Paddle === undefined)
            return;

        // var env = global.Paddle.Environment.get();

        global.Paddle.Checkout.open({
        settings: {
            theme: "dark"
        },
        items: [
            {
            priceId: productPath,
            quantity: 1
            },
        ]
        });
    }
}

const PageViewWithHooks = (props) => {
    const params = useParams();
    const navigate = useNavigate();
    const shop = useShop();

    const ssr = useContext(SsrPageContext);
    if (ssr) {
        ssr.pageViewRendered = true;
    }

    return (
        <PageView
            {...props}
            params={params}
            navigate={navigate}
            products={shop}
            data={shop}
            initialData={props.initialData}
        />
    );
};
export default PageViewWithHooks;